import Modal from './modal';

export default Modal;
export { Modal };
